export const ACTIONS = {
  LOADER: "SET_LOADER",
  TOGGLE_MODAL: "TOGGLE_MODAL",
  ALL_VIDEOS: "ALL_VIDEOS",
  SEARCH_VIDEO: "SEARCH_VIDEO",
  CLEAR_SEARCH: "CLEAR_SEARCH",
  SET_WATCHLATER: "SET_WATCHLATER",
  TOGGLE_WATCHLATER: "TOGGLE_WATCHLATER",
  CREATE_NEW_PLAYLIST: "CREATE_NEW_PLAYLIST",
  TOGGLE_PLAYLIST: "TOGGLE_PLAYLIST",
  DELETE_VIDEO_FROM_PLAYLISTS: "DELETE_VIDEO_FROM_PLAYLISTS",
  DELETE_PLAYLIST: "DELETE_PLAYLIST",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  SET_FAVOURITES: "SET_FAVOURITES",
  TOGGLE_FAVOURITES: "TOGGLE_FAVOURITES",
  SET_HISTORY: "SET_HISTORY",
  ADD_VIDEO_IN_HISTORY: "ADD_VIDEO_IN_HISTORY",
  REMOVE_VIDEO_FROM_HISTORY: "REMOVE_VIDEO_FROM_HISTORY",
  CLEAR_HISTORY: "CLEAR_HISTORY",
  TOGGLE_TOAST: "TOGGLE_TOAST",
  SET_NOTES: "SET_NOTES",
  ADD_NOTE: "ADD_NOTE",
  UPDATE_NOTE: "UPDATE_NOTE",
  DELETE_NOTE: "DELETE_NOTE",
};
